<div *ngIf="!showRequest">

  <h2 *ngIf="isShow" class="sectionTitle">{{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_FORM' | translate }}</h2>

  <div *ngIf="baseRequestId" class="read-only-content">
    <!--request Details summary-->
    <app-entrance-request [IsAdminMode]="true" [AgentId]="agentId"></app-entrance-request>
  </div>

  <!-- <div *ngIf="baseRequestId"> -->
  <form #estimateFees [formGroup]="estimateFeesForm">
    <!-- Reviewing Section -->
    <fieldset [disabled]="this.estimateFeesForm.disabled">
      <div class="form-container">
        <div class="form-section">
          <h4 class="section-title">{{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MEASUREMENT_DECISION'| translate}}</h4>
          <div class="form-group">
            <label for="Decision">{{'ADMIN_USER.SmallUnits.DECISION' | translate}}</label>
            <span class="red">*</span>
            <div class="form-custom-inputs">
              <div *ngFor="let decisions of decisionKeys;let i='index'" class=" custom-Radio">
                <input type="radio" [id]=[decisions] (change)="changeDecision(decision[decisions])"  name="Decision"
                   [value]="decision[decisions]" formControlName="Decision" />
                <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>
              </div>
            </div>
            <div *ngIf="submitted && f.Decision?.errors" class="red">
              <div *ngIf="f.Decision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            </div>
          </div>


          <div *ngIf="decisionValue == decision.Reject" class="form-group">
            <label for="decisionValue">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' |
              translate}}</label>
            <span class="red">*</span>
            <textarea formControlName="MeasEstimationRejectReason" id="MeasEstimationRejectReason" name="MeasEstimationRejectReason"
              class="form-control"
              [ngClass]="{ 'is-invalid': submitted ||(f.MeasEstimationRejectReason?.dirty && f.MeasEstimationRejectReason?.errors) }"></textarea>
            <div *ngIf="submitted ||(f.MeasEstimationRejectReason?.dirty && f.MeasEstimationRejectReason?.errors)" class="red">
              <div *ngIf="f.MeasEstimationRejectReason?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>

          </div>
        
        <div *ngIf="decisionValue == decision.MoreInformation" class="form-group">
          <label for="MeasEstimationMoreInformation">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' | translate}}</label>
          <span class="red">*</span>
          <textarea formControlName="MeasEstimationMoreInformation" id="MeasEstimationMoreInformation" name="MeasEstimationMoreInformation" class="form-control"
            [ngClass]="{ 'is-invalid': submitted ||(f.MeasEstimationMoreInformation?.dirty && f.MeasEstimationMoreInformation?.errors) }"></textarea>
          <div *ngIf="submitted ||(f.MeasEstimationMoreInformation?.dirty && f.MeasEstimationMoreInformation?.errors)" class="red">
            <div *ngIf="f.MeasEstimationMoreInformation?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
          </div>

        </div>
      </div>
      </div>
    </fieldset>
    <div class="form-container">

      <!-- Fees Section -->
      <div *ngIf="decisionValue == decision.Approve" class="form-section">

        <!-- Fees Group -->
        <h4 class="section-title">{{'ADMIN_USER.SmallUnits.ESTIMATED_MEASURMENT_FEES'| translate}}</h4>

        <div class="form-group">
          <label for="EstimatedNetTonnage">{{ 'ADMIN_USER.SmallUnits.ESTIMATED_FEES_NET_TONNAGE' | translate}}</label>
          <span class="red">*</span>
          <input type="text" formControlName="EstimatedNetTonnage" id="EstimatedNetTonnage" name="EstimatedNetTonnage" (change)="NetTonnageChanged($event)" class="form-control" />
          <div *ngIf="submitted || (f.EstimatedNetTonnage?.dirty &&f.EstimatedNetTonnage?.errors)" class="red">
            <div *ngIf="f.EstimatedNetTonnage?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
            <div *ngIf="f.EstimatedNetTonnage?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
                <div *ngIf="f.EstimatedNetTonnage?.errors?.max">
                  {{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MAX_NET_TONNAGE' | translate}}
                </div>
          </div>
        </div>
        <div class="form-group">
          <label for="EstimatedSDR">{{ 'ADMIN_USER.SmallUnits.ESTIMATED_FEES_SDR_RATE' | translate}}</label>
          <span class="red">*</span>
          <input type="text" formControlName="EstimatedSDR" id="EstimatedSDR" name="EstimatedSDR" (change)="SDRChanged($event)" class="form-control" />
          <div *ngIf="submitted || (f.EstimatedSDR?.dirty &&f.EstimatedSDR?.errors)" class="red">
            <div *ngIf="f.EstimatedSDR?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
            <div *ngIf="f.EstimatedSDR?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
          </div>
        </div>

        <div class="form-group">
          <label for="EstimatedFeesValue">{{ 'ADMIN_USER.SmallUnits.ESTIMATED_FEES_FEES' | translate}}</label>
          <span class="red">*</span>
          <input type="text" formControlName="EstimatedFeesValue" id="EstimatedFeesValue" name="EstimatedFeesValue"
            class="form-control" />
          <div *ngIf="submitted || (f.EstimatedFeesValue?.dirty &&f.EstimatedFeesValue?.errors)" class="red">
            <div *ngIf="f.EstimatedFeesValue?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
            <div *ngIf="f.EstimatedFeesValueValue?.errors?.pattern">
                  {{'FRONT_USER.NUMBER_ERROR' | translate}}
                </div>
          </div>
        </div>


      </div>
      <div *ngIf="formMode == FormMode.Add" class="form-group">
        <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
          'FRONT_USER.SUBMIT' | translate}}</button>
      </div>
    </div>
  </form>

  <br>

  <!-- </div> -->
</div>
<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>

  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>